import { render, staticRenderFns } from "./sectionSmallHome.vue?vue&type=template&id=1bba29b2&"
import script from "./sectionSmallHome.vue?vue&type=script&lang=js&"
export * from "./sectionSmallHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sectionSmallHome.vue"
export default component.exports